import React, { useEffect, useState } from "react";
import { Radio, ArrowRight } from "lucide-react";
import { fetchSettings } from "@/lib/api";

const HOURS = (iso) => {
  if (!iso) return "";
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const h = Math.floor(diff / 3600000);
  const d = Math.floor(h / 24);
  if (d >= 1) return `${d} day${d > 1 ? "s" : ""} ago`;
  if (h >= 1) return `${h} hour${h > 1 ? "s" : ""} ago`;
  const m = Math.floor(diff / 60000);
  return `${Math.max(1, m)} min ago`;
};

/**
 * LivePreviewCard — small "Felicia was live 2h ago" replay card that appears
 * on the home page (only when there's no active live and there IS a recent
 * live session in the site settings).
 */
export const LivePreviewCard = () => {
  const [state, setState] = useState(null);
  useEffect(() => {
    fetchSettings().then(setState).catch(() => {});
  }, []);
  if (!state || state.live?.active || !state.recent_live) return null;
  const r = state.recent_live;
  return (
    <a
      href={r.url || "#"}
      target={r.url ? "_blank" : undefined}
      rel="noreferrer"
      data-testid="live-preview-card"
      className="group inline-flex items-center gap-4 p-4 pr-6 bg-emerald text-cream border border-gold/40 hover:border-gold transition-colors"
      style={{ background: "linear-gradient(90deg,#0A2416 0%,#0F3821 100%)" }}
    >
      <div className="relative flex items-center justify-center w-11 h-11 border border-gold/50 shrink-0">
        <Radio className="w-5 h-5 text-gold" />
        <span className="absolute -top-1 -right-1 w-2 h-2 bg-gold rounded-full opacity-70" />
      </div>
      <div className="min-w-0">
        <p className="font-body text-[10px] uppercase tracking-[0.28em] text-gold mb-0.5">
          Felicia was live · {HOURS(r.ended_at)}
        </p>
        <p className="font-display text-base leading-tight text-cream truncate max-w-xs">
          {r.title}
        </p>
        {r.message && (
          <p className="font-body text-xs text-cream/60 truncate max-w-xs mt-0.5">
            {r.message}
          </p>
        )}
      </div>
      {r.url && (
        <span className="font-body text-xs text-gold group-hover:translate-x-1 transition-transform inline-flex items-center gap-1 shrink-0">
          Watch replay <ArrowRight className="w-3.5 h-3.5" />
        </span>
      )}
    </a>
  );
};

export default LivePreviewCard;
